import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchConnectors () {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/connectors`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.get(url, { cancelToken: source.token }).then(response => response.data)
}

export default {
  fetchConnectors,
}
